export const types = {
  GET_ENTREGADOR: 'GET_ENTREGADOR',
};